import { render, staticRenderFns } from "./OrderItemTrackingTable.vue?vue&type=template&id=6137b8ff&scoped=true"
import script from "./OrderItemTrackingTable.vue?vue&type=script&lang=js"
export * from "./OrderItemTrackingTable.vue?vue&type=script&lang=js"
import style0 from "./OrderItemTrackingTable.vue?vue&type=style&index=0&id=6137b8ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6137b8ff",
  null
  
)

export default component.exports